import { render, staticRenderFns } from "./DisapprovedReasonList.vue?vue&type=template&id=a36da6d6"
import script from "./DisapprovedReasonList.vue?vue&type=script&lang=js"
export * from "./DisapprovedReasonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports